import "./CoachingSessions.module.css";
import Encabezado from "@/reusable_sections/Header";
import HeroDeSesiones from "./sections/HeroDeSesiones";
import TiposDeSesiones from "./sections/TiposDeSesiones";
import ReservaTuSesion from "./sections/ReservaTuSesion";
import HistoriasRealesDeClaridad from "./sections/HistoriasRealesDeClaridad";
import PieDePA_gina from "@/reusable_sections/Footer";
export default function CoachingSessionsPage() {
  return <div>
      <Encabezado />
      <HeroDeSesiones />
      <TiposDeSesiones />
      <HistoriasRealesDeClaridad />
      <ReservaTuSesion />
      <PieDePA_gina />
    </div>;
}